import { LocalStorageKey } from './client_local_storage.ts';
import { useLocalStorage } from './use_local_storage.tsx';
import { useUserAttributes } from './use_user_attributes.ts';

export function useIsAutoPlayNextSongEnabled(): boolean {
  const [autoPlayNextSong] = useLocalStorage(LocalStorageKey.AutoPlayNextSong);
  const { isOrgAdmin, isStaff } = useUserAttributes();
  if (autoPlayNextSong !== undefined) {
    return autoPlayNextSong;
  }
  return !isOrgAdmin && !isStaff;
}
